import React from "react";
import Joi from "joi-browser";
import Form from "../common/form/form";
import { getSeason, saveSeason } from "./../../services/seasonService";
import { getLeagues } from "./../../services/leagueService";
import _ from "lodash";

class SeasonForm extends Form {
  state = {
    allLeagues: [],
    data: { id: -1, name: "", leagues: [] },
    errors: {}
  };

  schema = {
    id: Joi.number(),
    name: Joi.string().required(),
    leagues: Joi.array().optional()
  };

  async componentDidMount() {
    const { match, history } = this.props;

    this.setState({ allLeagues: await getLeagues() });

    const seasonId = match.params.id;
    if (seasonId === "new") return;

    const season = await getSeason(seasonId);
    if (!season) return history.replace("/not-found");

    this.setState({ data: this.mapToViewModel(season) });
  }

  mapToViewModel(season) {
    return {
      id: season.id,
      name: season.name,
      leagues: _.map(season.leagues, "id")
    };
  }

  doSubmit = async () => {
    await saveSeason(this.state.data);
    this.props.history.push("/seasons");
  };

  handleCheckBoxChange = (e, leagueId) => {
    const isChecked = e.target.checked;
    const { data } = this.state;

    if (isChecked) data.leagues.push(leagueId);
    else data.leagues.splice(data.leagues.indexOf(leagueId), 1);

    this.setState({ data });
  };

  render() {
    const { allLeagues, data } = this.state;

    return (
      <div>
        <h2>Season</h2>
        <form onSubmit={this.handleSubmit}>
          {this.renderLink("/seasons", "fa fa-arrow-left", "btn btn-secondary")}
          {this.renderButton("fa fa-save", "btn btn-success m-1")}
          {this.renderInput("name", "Name", true)}
          {allLeagues.map(league => (
            <div key={league.id}>
              <input
                type="checkbox"
                id={league.id}
                onClick={e => this.handleCheckBoxChange(e, league.id)}
                checked={data.leagues.indexOf(league.id) !== -1}
              />
              <label htmlFor={league.id}>{league.name}</label>
            </div>
          ))}
        </form>
      </div>
    );
  }
}

export default SeasonForm;



// WEBPACK FOOTER //
// ./src/components/seasons/seasonForm.jsx